import angular from 'angular';
import { IVisualizacaoPreviaUploadModalData } from './models/visualizacao-previa-upload.modal.model';

export class VisualizacaoPreviaUploadModalService {
    static $inject = ['$uibModal'];

    constructor(public $uibModal: ng.ui.bootstrap.IModalService) {}

    open(entity: IVisualizacaoPreviaUploadModalData) {
        return this.$uibModal.open({
            template: require('html-loader!./visualizacao-previa-upload.modal.html'),
            controller: 'VisualizacaoPreviaUploadModalController',
            controllerAs: '$ctrl',
            backdrop: 'static',
            windowClass: 'nsj-modal-lg-no-height',
            resolve: {
                entity: () => angular.copy(entity)
            }
        });
    }
}
